import { Tooltip } from '@innovationdepartment/proxima-ui';
import { type BackendSupport, SUPPORT_BADGES } from '../../lib/audienceFields';
import { Badge } from './FilterRules.styles';

/** "Proposed" with its tooltip; nothing for supported columns. */
const SupportBadge = ({ support }: { support: BackendSupport | undefined }) => {
  if (!support || support === 'supported') return null;
  const badge = SUPPORT_BADGES[support];
  return (
    <Tooltip title={badge.tooltip}>
      <Badge tone={support} aria-label={`${badge.label}: ${badge.tooltip}`}>
        {badge.label}
      </Badge>
    </Tooltip>
  );
};

export default SupportBadge;
